const amountSelection = {
  title: 'How much would you like to borrow?',
  ddAmountListTitle: 'Amounts you qualify for with deposits at Varo:',
  externalAccountsAmountListTitle:
    'Amounts you qualify for with your linked account:',
  externalAccountsAmountsListBody:
    'To access Advance funds through a linked account, you’ll need to provide both debit card and ACH payment authorizations.',
  showMoreButton: 'Show more',
  showLessButton: 'Show less',
  borrowingPower: 'Grow your borrowing power',
  amountSelectionButtonTitle: 'Fee',
  forFullPriceDetailsSee: `For full pricing details, see `,
  termsAndConditions: 'Terms and Conditions.',
  error: {
    title: 'Oops! Something went wrong.',
    body: 'Please try again later',
    button: 'Done',
  },
  inlineAlert: {
    title: "Your linked account doesn't qualify for higher advance amounts",
    body: "We'll send an email with more information.",
  },
};

export default amountSelection;
